import { Diversity3Outlined, HomeOutlined, StorefrontOutlined } from "@mui/icons-material";

export const visitorManagementPrimaryNav = [
  { Icon: HomeOutlined, end: true, label: "Home", to: "." },
  { Icon: Diversity3Outlined, end: false, label: "Reunification", to: "reunification" },
  { Icon: StorefrontOutlined, end: false, label: "Kiosk", to: "kiosk" },
] as const;
